<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">Registrar Cliente</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="submitClient">
                            <h6 class="text-uppercase text-body text-sm font-weight-bolder">Datos de Identificación</h6>
                            <div class="row">


                                <div class="col-md-6">
                                    <label for="document" class="form-control-label">Documento</label>
                                    <argon-input id="document" type="text" v-model="client.document" placeholder="Número de Documento" />
                                </div>

                                <div class="col-md-12 mt-3">
                                    <label for="clientName" class="form-control-label">Nombres y Apellidos</label>
                                    <argon-input id="clientName" type="text" v-model="client.name" />
                                    <small v-if="submitted && v$.client.name.$error" class="text-danger">Nombre es requerido</small>
                                </div>

                                                                <div class="col-md-6 mt-3">
                                    <label for="gender" class="form-control-label">Género</label>
                                    <argon-select id="gender" class="form-control" v-model="client.gender" :choices="genders"/>
                                    <small v-if="submitted && v$.client.gender.$error" class="text-danger">Género es requerido</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label for="phone" class="form-control-label">Teléfono</label>
                                    <argon-input id="phone" type="text" v-model="client.phone" />
                                </div>
                                <div class="col-md-6 mt-3">
                                    <label for="email" class="form-control-label">Correo</label>
                                    <argon-input id="email" type="text" v-model="client.email" />

                                </div>
                                <div class="col-md-6 mt-3">
                                    <label for="nationality" class="form-control-label">Nacionalidad</label>
                                    <argon-select id="nationality" class="form-control" v-model="client.nationality" :choices="nationalities"/>
                                </div>

                                <hr class="horizontal dark mt-4 mb-3" />
                                <div class="col-md-12 mt-3">
                                    <label class="form-label font-weight-bold">Ubicación del Punto de Gestión (Opcional)</label>
                                    <div id="task-map" class="border-radius-lg shadow-sm mb-2" style="height: 300px; z-index: 1;"></div>
                                    <div class="row">
                                        <div class="col-6">
                                        <argon-input v-model="client.latitude" placeholder="Latitud" readonly size="sm" />
                                        </div>
                                        <div class="col-6">
                                        <argon-input v-model="client.longitude" placeholder="Longitud" readonly size="sm" />
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-6">
                                    <label for="department" class="form-control-label">Departamento</label>
                                    <ArgonLookup
                                        id="department"
                                        :options="departments"
                                        v-model="client.department_object"
                                        display-key="text"
                                        track-by="value"
                                        placeholder="Busque el departamento..."
                                        @update:modelValue="handleDepartmentLookupChange"
                                    />
                                </div>

                                <div class="col-md-6">
                                    <label for="city" class="form-control-label">Ciudad/Municipio</label>
                                    <ArgonLookup
                                        id="city"
                                        :options="filteredCities"
                                        v-model="client.city_object"
                                        display-key="text"
                                        track-by="value"
                                        placeholder="Seleccione la ciudad..."
                                        :disabled="!client.department"
                                        @update:modelValue="handleCityLookupChange"
                                    />
                                </div> -->

                                <div class="col-md-12 mt-3">
                                    <label for="address" class="form-control-label">Dirección de Residencia</label>
                                    <argon-textarea id="address" type="text" v-model="client.address"/>
                                    <small v-if="submitted && v$.client.address.$error" class="text-danger">Dirección es requerida</small>
                                </div>

                                <div class="col-md-12 mt-3">
                                    <label class="form-control-label">Archivos (Documentos y Foto)</label>
                                </div>

                                <div class="col-md-4 text-center">
                                    <label class="form-control-label">Foto del cliente</label>
                                    <div class="image-upload-area" @click="uploadPhoto('photo')">
                                        <img :src="client.photo_url || fileUpload" alt="Foto cliente" class="img-thumbnail" style="max-width:100%; height: auto;" />
                                        <input type="file" style="display: none !important;" ref="clientPhotoFile" accept="image/jpeg, image/png" @change="onFileChange('photo', $event)">
                                    </div>
                                </div>

                                <div class="col-md-4 text-center">
                                    <label class="form-control-label">Documento Frontal</label>
                                    <div class="image-upload-area" @click="uploadPhoto('documentFront')">
                                        <img :src="client.document_front_url || fileUpload" alt="Doc Frontal" class="img-thumbnail" style="max-width:100%; height: auto;" />
                                        <input type="file" style="display: none !important;" ref="clientFrontFile" accept="image/jpeg, image/png" @change="onFileChange('front', $event)">
                                    </div>
                                </div>

                                <div class="col-md-4 text-center">
                                    <label class="form-control-label">Documento Trasero</label>
                                    <div class="image-upload-area" @click="uploadPhoto('documentBack')">
                                        <img :src="client.document_back_url || fileUpload" alt="Doc Trasero" class="img-thumbnail" style="max-width:100%; height: auto;" />
                                        <input type="file" style="display: none !important;" ref="clientBackFile" accept="image/jpeg, image/png" @change="onFileChange('back', $event)">
                                    </div>
                                </div>

                            </div>

                            <argon-button
                                type="submit"
                                class="mt-4"
                                color="success"
                                fullWidth
                                size="lg"
                            >Guardar</argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSelect from "@/components/ArgonSelect.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";
import ArgonButton from "@/components/ArgonButton.vue";
// import ArgonLookup from "@/components/ArgonLookup.vue"
import { useCompanyConfig } from '@/composables/useCompanyConfig';
import { useStatics } from '@/composables/useStatics';
import {useVuelidate} from '@vuelidate/core';
import {required} from '@vuelidate/validators';
import axios from "axios";
import Swal from 'sweetalert2';
import fileUpload from '@/assets/img/uploadfile.jpg';
import L from 'leaflet';
//const companyId =localStorage.getItem('companyId');
const { ethnicities, nationalities, departments, cities } = useStatics();
const DEFAULT_CENTER = [13.689, -89.187]; // Ajusta a tu ciudad por defecto

export default {
    name: "CreatePatient",
    setup(){
        const { companyConfig, isLoadingCiaConfig, fetchCompanyConfig } = useCompanyConfig();
        fetchCompanyConfig();

        return {
            companyConfig,
            isLoadingCiaConfig,
            v$: useVuelidate()
        };
    },
    data() {
        const companyId = parseInt(localStorage.getItem('companyId'));
        return {
            map: null,
            fileUpload,
            submitted:false,
            nationalities,
            cities,
            ethnicities,
            departments,
            client: {
                document: null,      // Reemplaza 'nit'
                name: null,
                //date_of_birth: null, // NUEVO
                gender: null,        // NUEVO
                email: null,
                phone: null,
                address: null,       // Reemplaza fiscal_address/commercial_address
                company: companyId || null,
                photo_url: null,
                document_front_url: null,
                document_back_url: null,
                department: null,          // FK ID (para BD)
                city: null,                // FK ID (para BD)
                latitude:0,
                longitude:0,
                //department_object: null,   // Objeto seleccionado del lookup
                //city_object: null,         // Objeto seleccionado del lookup
            },

            genders: [ // Lista para el campo 'gender'
                { value: 'M', text: 'Masculino' },
                { value: 'F', text: 'Femenino' },
                { value: 'O', text: 'Otro' },
            ],
            // Las demás listas (clientTypes, locations, etc.) se han ELIMINADO del objeto data.
        };
    },
    watch:{
    },
    components: {
        ArgonInput,
        ArgonButton,
        ArgonTextarea,
        ArgonSelect,
        // ArgonLookup
    },
    computed: {
        filteredCities() {
            const deptId = parseInt(this.client.department);
            if (!deptId) {
                return [];
            }
            return this.cities.filter(city => city.department_id === deptId);
        }
    },
    validations(){
        return{
            client: {
                name: { required },
                gender: { required },
                address: { required }, // Dirección es clave
                company: { required },
            },
        }
    },
    methods:{
        initializeMap() {
            this.map = L.map('task-map').setView(DEFAULT_CENTER, 13);
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OpenStreetMap'
            }).addTo(this.map);

            // Icono por defecto (Fix para Webpack/Vite)
            const icon = L.icon({
                iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
                iconUrl: require('leaflet/dist/images/marker-icon.png'),
                shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
                iconSize: [25, 41],
                iconAnchor: [12, 41]
            });

            this.marker = L.marker(DEFAULT_CENTER, { draggable: true, icon }).addTo(this.map);

            // Evento: Arrastrar marcador
            this.marker.on('dragend', () => {
                const position = this.marker.getLatLng();
                this.client.latitude = position.lat.toFixed(8);
                this.client.longitude = position.lng.toFixed(8);
            });

            // Evento: Click en mapa
            this.map.on('click', (e) => {
                this.marker.setLatLng(e.latlng);
                this.client.latitude = e.latlng.lat.toFixed(8);
                this.client.longitude = e.latlng.lng.toFixed(8);
            });
            },
        handleDepartmentLookupChange(selectedObject) {
            if (selectedObject) {
                // Asigna el ID (value) al campo FK de la BD
                this.client.department = selectedObject.value;
            } else {
                this.client.department = null;
            }
            // CRUCIAL: Resetea la ciudad/municipio dependiente
            this.client.city = null;
            this.client.city_object = null;
        },

        handleCityLookupChange(selectedObject) {
            if (selectedObject) {
                // Asigna el ID (value) al campo FK de la BD
                this.client.city = selectedObject.value;
            } else {
                this.client.city = null;
            }
        },
        // Lógica de carga de fotos (Mantenida)
        uploadPhoto(e){
             if(e=='documentFront'){
                this.$refs.clientFrontFile.click();
            }else if(e=='documentBack'){
                this.$refs.clientBackFile.click();
            }else{
                this.$refs.clientPhotoFile.click();
            }
        },
        // Lógica de cambio de archivo (Mantenida)
        onFileChange(type, event){
            let self=this;
            const file = event.target.files[0];
            let formData=new FormData();
            let filename='jpg';
            if(file){
                formData.append('file', file);
                formData.append('fileName', filename);
                axios.post(this.$store.state.fileURL, formData,
                    {
                    headers: {
                        "Authorization": "Basic cHJpdmF0ZV9XVXVROG1DQncxV210WHc1empIa3NGQkNZQ1E9Og==",
                        'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'
                    }
                }).then(function(result){
                    if(type=='front'){
                        self.client.document_front_url=result.data.url;
                    }else if(type=='back'){
                        self.client.document_back_url=result.data.url;
                    }else{
                        self.client.photo_url=result.data.url;
                    }
                }).catch(err => {
                    console.error("Error al subir archivo:", err);
                    Swal.fire('Error', 'Fallo al subir el archivo.', 'error');
                });
            }
        },

        // LÓGICA DE SUBMIT (submitClient)
        async submitClient(){
            this.submitted = true;
            this.v$.$touch();

            if(this.v$.$invalid){
                Swal.fire({
                    title: 'Error en validación',
                    text: 'Por favor, revisa los campos obligatorios.',
                    icon:'error',
                    confirmButtonColor:'#0b9257',
                });
                return;
            }

            const payload = { ...this.client };
            // Aseguramos que no queden objetos de lookup que no existen en la BD
            delete payload.department_object;
            delete payload.city_object;

            const token = localStorage.getItem("accessToken");
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            };
            //const reservedNumber = await this.getNextSerial();
            //this.client.record_number = reservedNumber;
            try {
                await axios.post(this.$store.state.apiURL + 'clients', payload, config);

                Swal.fire({
                    title: 'Cliente Creado',
                    text: 'Se insertó la información del cliente de manera satisfactoria.',
                    icon:'success',
                    confirmButtonColor:'#0b9257',
                }).then(() => {
                    this.$router.push('/clients');
                });

            } catch (err) {
                console.error('Error al crear cliente:', err.response || err);
                let errorText = 'Fallo al guardar el cliente.';

                if (err.response && err.response.data && err.response.data.error) {
                    errorText = err.response.data.error.includes('Duplicate entry')
                        ? 'Ya existe un cliente con ese N° de Expediente.'
                        : err.response.data.error;
                }

                Swal.fire({
                    title: 'Error',
                    text: errorText,
                    icon:'error',
                    confirmButtonColor:'#0b9257',
                });
            }
        },
        async mounted() {
            // Ya no se necesita cargar ninguna lista de referencia externa.
            this.loading = false;
        },
        async getNextSerial() {
            //const dteType = this.factura.header.dte_type || '01';
            // Convertir el string DTE (01, 03, 14) al número entero esperado por la tabla `serial`.
            let serialType = 0;


            const token = localStorage.getItem("accessToken");
            const apiURL = this.$store.state.apiURL;

            if (!token) {
                this.$swal('Error de Sesión', 'Acceso denegado. Reinicie sesión.', 'error');
                throw new Error("No token");
            }

            try {
                const payload = {
                    type: serialType,
                    company: this.companyConfig.id,
                    excent: 0
                };

                const response = await axios.post(
                    apiURL + 'serial/reserve_next',
                    payload,
                    { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } }
                );

                console.log('Número de Control Reservado:', response.data.full_number);
                return response.data;

            } catch (error) {
                console.error("Error al obtener y reservar el serial:", error.response || error);

                const errorText = error.response?.data?.error || 'No se pudo reservar el número consecutivo. Intente de nuevo.';
                this.$swal('Error de Serial', errorText, 'error');
                throw new Error("Serial Reservation Failed");
            }
        },

    },
    mounted(){
        this.initializeMap();
    }
};
</script>

<style scoped>
.image-upload-area {
    cursor: pointer;
    border: 2px dashed #ccc;
    padding: 10px;
    margin-top: 10px;
    border-radius: 8px;
    display: inline-block;
}
.image-upload-area:hover {
    border-color: #5e72e4;
}
</style>